import { render, staticRenderFns } from "./story-card.vue?vue&type=template&id=2ab0c9f6&scoped=true&"
import script from "./story-card.vue?vue&type=script&lang=js&"
export * from "./story-card.vue?vue&type=script&lang=js&"
import style0 from "./story-card.vue?vue&type=style&index=0&id=2ab0c9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0c9f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab0c9f6')) {
      api.createRecord('2ab0c9f6', component.options)
    } else {
      api.reload('2ab0c9f6', component.options)
    }
    module.hot.accept("./story-card.vue?vue&type=template&id=2ab0c9f6&scoped=true&", function () {
      api.rerender('2ab0c9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/story-card.vue"
export default component.exports